import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'relativeTimeFormat',
})
export class RelativeTimeFormatPipe implements PipeTransform {
  transform(value: Date | string | number | null, locale = 'pl'): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    const now = new Date();
    const diffInSeconds = Math.floor((date.getTime() - now.getTime()) / 1000);

    const rtf = new Intl.RelativeTimeFormat(locale, {numeric: 'auto'});

    const intervals = [
      {unit: 'year', seconds: 31536000},
      {unit: 'month', seconds: 2592000},
      {unit: 'week', seconds: 604800},
      {unit: 'day', seconds: 86400},
      {unit: 'hour', seconds: 3600},
      {unit: 'minute', seconds: 60},
      {unit: 'second', seconds: 1},
    ];

    for (const interval of intervals) {
      const count = Math.round(diffInSeconds / interval.seconds);
      if (Math.abs(count) >= 1) {
        return rtf.format(count, interval.unit as Intl.RelativeTimeFormatUnit);
      }
    }

    return rtf.format(0, 'second').toString();
  }
}
